const textAreaStyles = {
  padding: '5px 7px'
};
var textAreaStyles$1 = textAreaStyles;

export { textAreaStyles$1 as t };
//# sourceMappingURL=textarea-afd01524.js.map
